module.exports = __webpack_public_path__ + "static/media/Open-sans-kursiv.3365f92d.png";